import React, { useState, useEffect } from "react";
import useToken from "hooks/useToken";
import { useToast } from 'context/providers/ToastProvider';
import { Card, Col, Form, Row } from 'react-bootstrap';
import SoftBadge from 'components/common/SoftBadge';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import SkeletonTable from '../../../components/common/SkeletonTable'

const ListaActivoFijo = () => {


    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [activoFijo, setActivoFijo] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [responsableSeleccionado, setResponsableSeleccionado] = useState(0);


    const columns = [
        {
            accessor: 'idActivoFijo',
            Header: 'ID',
            width: 80,
            className: 'text-start',
            headerClassName: 'text-start bg-light small',
            Cell: rowData => {
                const { idActivoFijo } = rowData.row.original;
                return (
                    <Link
                        to={`/contabilidad/activofijo/editar/${idActivoFijo}`}
                        style={{ textDecoration: 'none', color: 'blue' }}
                    >
                        <span className="fw-bold d-block">
                            {idActivoFijo}
                        </span>
                    </Link>
                );
            }
        },
        {
            accessor: 'iEstadoActivo',
            Header: 'Estado',
            className: 'text-start',
            headerClassName: 'text-start bg-light small',
            Cell: rowData => {
                const { iEstadoActivo } = rowData.row.original;
                return (
                    <SoftBadge
                        bg={iEstadoActivo == 1 ? "success" : iEstadoActivo == 0 ? "danger" : "warning"}
                        style={{ cursor: "pointer" }}
                    >
                        {iEstadoActivo == 1 ? "Activo" : iEstadoActivo == 0 ? "No Activo" : "En reparación"}
                    </SoftBadge>
                );
            }
        },


        {
            accessor: 'idCategoria',
            Header: 'CT',
            headerProps: { className: 'pe-1' },
            headerClassName: 'text-start bg-light small',
            Cell: rowData => {
                const { idCategoria } = rowData.row.original;

                // Definir las categor�as con su ID y nombre
                var categoria = "";
                switch (idCategoria) {
                    case 1: categoria = "Electrónica"; break;
                    case 2: categoria = "Mobiliario"; break;
                    case 3: categoria = "Vehículos"; break;
                    case 4: categoria = "Inmuebles"; break;
                    case 5: categoria = "Otros"; break;

                }


                return (
                    <span className="d-inline-block text-truncate">
                        {categoria || "Desconocido"}
                    </span>
                );
            }
        },
        {
            accessor: 'dCostoAdquisicion',
            Header: 'Costo',
            Cell: rowData => {
                const { dCostoAdquisicion } = rowData.row.original;

                return <span className="fs--2 fw-bold">
                    {
                        parseFloat(dCostoAdquisicion).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                            style: 'currency', currency: 'MXN'
                        })
                    }
                </span>
            }
        },
        {
            accessor: 'vNumeroRegistro',
            Header: 'Num. Reg.',
            Cell: rowData => {
                const { vNumeroRegistro } = rowData.row.original;
                return <span> {vNumeroRegistro}</span>;
            }
        },
        {
            accessor: 'vNumeroSerie',
            Header: 'Numero Serie',
            Cell: rowData => {
                const { vNumeroSerie } = rowData.row.original;
                return <span> {vNumeroSerie}</span>;
            }
        },
        {
            accessor: 'vNombreActivo',
            Header: 'Nombre de Activo',
            Cell: rowData => {
                const { vNombreActivo } = rowData.row.original;
                return <span className="d-inline-block text-truncate" style={{ maxWidth: '250px' }}> {vNombreActivo} </span>
            }
        },
        {
            accessor: 'dFechaCompra',
            Header: 'Fecha de Compra',
            Cell: rowData => {
                const rawFecha = rowData.row.original?.dFechaCompra;
                //console.log("Fecha cruda en celda:", rawFecha);

                if (!rawFecha) return <span>Sin fecha</span>;

                // Si la fecha viene con hora ("YYYY-MM-DDTHH:mm:ss"), tomar solo la parte de la fecha
                //const fechaFormateada = rawFecha.includes("T") ? rawFecha.split("T")[0] : rawFecha;
                return <span>{new Date(rawFecha).toLocaleDateString('es-mx', { year: 'numeric', month: 'short', day: 'numeric' })}</span>;
                //return <span>{fechaFormateada}</span>;
            }
        },
        {
            accessor: 'dFechaUso',
            Header: 'Fecha de uso',
            Cell: rowData => {
                const rawFecha = rowData.row.original?.dFechaUso;
                //console.log("Fecha cruda en celda:", rawFecha);

                if (!rawFecha) return <span>Sin fecha</span>;

                // Si la fecha viene con hora ("YYYY-MM-DDTHH:mm:ss"), tomar solo la parte de la fecha
                //const fechaFormateada = rawFecha.includes("T") ? rawFecha.split("T")[0] : rawFecha;
                return <span>{new Date(rawFecha).toLocaleDateString('es-mx', { year: 'numeric', month: 'short', day: 'numeric' })}</span>;
                //return <span>{fechaFormateada}</span>;
            }
        },
        {
            accessor: 'vEmpleadoResponsable',
            Header: 'Responsable',
            Cell: rowData => {
                const { vEmpleadoResponsable } = rowData.row.original;
                return <>
                    <span>{vEmpleadoResponsable}</span>
                </>
            }
        },
        {
            accessor: 'vUbicacionActivo',
            Header: 'Ubicacion Activo',
            Cell: rowData => {
                const { vUbicacionActivo } = rowData.row.original;
                return <>
                    <span>{vUbicacionActivo}</span>
                </>
            }
        }




    ];

    /**
     * Funcion para obtener los empleados
     */
    const obtenerListaEmpleados = async () => {
        setCargando(true);
        const response = await fetch("/api/ActivoFijo/ObtenerEmpleados",
            {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response && response.ok) {
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles: ", ObjDetalles);

                setEmpleados(ObjDetalles.table2);

                // Selecciona el responsable solo la primera vez
                // NO llamar mostrarActivoFijo aquí


            } else {
                showErrorToast(data.vMessage);
            }
            setCargando(false);


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setCargando(false);

        }
    };

    /**
    * Funcion para obtener los activos fijos
    */
    const mostrarActivoFijo = async (idUsuario) => {

        console.log("idUsuario: ", idUsuario);

        setCargando(true);

        var dataToSend = {};
        dataToSend.idUsuario = idUsuario;
        setActivoFijo([]);


        const response = await fetch("/api/ActivoFijo/ObtenerActivoFijo",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("response: ", response);
            const data = await response.json();
            //console.log("data: ", data);


            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles: ", ObjDetalles);

                setActivoFijo(ObjDetalles.table2);
                setCargando(false);

            } else {
                showErrorToast(data.vMessage);
                setCargando(false);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            setCargando(false);
        }
    };

    useEffect(() => {
        mostrarActivoFijo(0);         // Consulta activos de inmediato
        obtenerListaEmpleados();    // Carga empleados en paralelo
    }, []);

    return (
        <>
            <AdvanceTableWrapper
                columns={columns}
                data={activoFijo}
                sortable
                pagination
                perPage={50}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <div className="d-flex flex-column gap-3">
                            <Row className="align-items-center g-3">
                                <Col xs={12} md={6} lg={4} xl={3}>
                                    <div className="filter-group">
                                        <Form.Label className="fw-semibold mb-1">
                                            Responsable
                                        </Form.Label>
                                        <Form.Select
                                            size="sm"
                                            aria-label="Filtrar por responsable"
                                            value={responsableSeleccionado}
                                            onChange={(e) => {
                                                setResponsableSeleccionado(e.target.value);
                                                mostrarActivoFijo(e.target.value);
                                            }}
                                            className="form-select-sm"
                                        >
                                            <option value="0">Todos los empleados</option>
                                            {empleados.map((empleado, index) => (
                                                <option key={empleado.idUsuario || index} value={empleado.idUsuario}>
                                                    {empleado.vNombre} {empleado.vApellidos}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} lg="auto" className="ms-auto">
                                    <div className="d-flex justify-content-end">
                                        <Link to="/contabilidad/activofijo/nuevo">
                                            <Button
                                                size="sm"
                                                variant="falcon-primary"
                                                className="d-flex align-items-center gap-2"
                                            >
                                                <i className="fas fa-plus" aria-hidden="true"></i>
                                                Nuevo Activo Fijo
                                            </Button>
                                        </Link>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} md={8} lg={6} xl={4} className="ms-auto">
                                    <div className="search-group">
                                        <AdvanceTableSearchBox table />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Card.Header>

                    <Card.Body className="p-0">
                        {cargando ? (
                            <SkeletonTable columnNames={['ID', 'Estado', 'CT', 'Costo', 'Num.Reg', 'Nombre de Archivo', 'Numero Serie', 'Responsable', 'Ubicacion Activo', 'Fecha de Uso']} rows={8} />
                        ) : (
                            <AdvanceTable
                                table
                                headerClassName="bg-200 text-900 text-nowrap align-middle"
                                rowClassName="align-middle white-space-nowrap"
                                tableProps={{
                                    size: 'sm',
                                    striped: true,
                                    className: 'fs--2 mb-0 overflow-hidden'
                                }}
                            />
                        )}
                    </Card.Body>

                    <Card.Footer>
                        <AdvanceTableFooter
                            rowCount={activoFijo.length}
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>

        </>
    );

}

export default ListaActivoFijo;